"use client";

import { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function HeaderMenuConsumer() {
  const {
    loading
  } = useMenu();
  if (loading) {
    return null;
  }
  return null;
}
export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <header className={`sticky top-0 z-50 w-full bg-light-background/95 backdrop-blur-md border-b border-border transition-all duration-300 ${isScrolled ? "h-[72px] shadow-soft" : "h-[96px]"}`}>
      <div className="container mx-auto px-4 h-full flex items-center justify-between">
        <div className="flex-shrink-0">
          <Link to="/" className="block">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1508139/img/vanessabrian_wedding_dresscode_logo.png" alt="Vanessa w Brian" className="h-7" />
          </Link>
        </div>

        <div className="flex-1 flex justify-center">
          <MenuProvider menu_id="3">
            <HeaderMenuConsumer />
          </MenuProvider>
        </div>

        <div className="flex-shrink-0 hidden md:block">
          <Button asChild className="bg-primary-dark text-white hover:bg-primary-dark hover:-translate-y-[3px] hover:shadow-medium transition-all duration-300 hover:!bg-primary-dark focus:!bg-primary-dark">
            <Link to="/#rsvp">RSVP</Link>
          </Button>
        </div>
      </div>
    </header>;
}